import { trpc } from '@tencent/tpro_rmonitor_product_manager_productoa';
import { TrpcRequestConfig } from '@/infrastructure/axios';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { logger } from '@/infrastructure/logger';
import { TrpcService } from '@/service/trpc';
import { RecursiveNonNullable, WithTypeCast } from '@raft/utils';
export type IAddProductOaReq = WithTypeCast<trpc.rmonitor.product_manager.IAddProductOaReq>;
export type IAddProductOaRsp = WithTypeCast<trpc.rmonitor.product_manager.IAddProductOaRsp>;
export type IDeleteProductOaReq = WithTypeCast<trpc.rmonitor.product_manager.IDeleteProductOaReq>;
export type IDeleteProductOaRsp = WithTypeCast<trpc.rmonitor.product_manager.IDeleteProductOaRsp>;
export type IUpdateProductOaReq = WithTypeCast<trpc.rmonitor.product_manager.IUpdateProductOaReq>;
export type IUpdateProductOaRsp = WithTypeCast<trpc.rmonitor.product_manager.IUpdateProductOaRsp>;
export type IGetProductOaListReq = WithTypeCast<trpc.rmonitor.product_manager.IGetProductOaListReq>;
export type IGetProductOaListRsp = WithTypeCast<trpc.rmonitor.product_manager.IGetProductOaListRsp>;
export type IProductOaListElem = WithTypeCast<trpc.rmonitor.product_manager.IProductOaListElem>;
export type IGetProductOaInfoReq = WithTypeCast<trpc.rmonitor.product_manager.IGetProductOaInfoReq>;
export type IGetProductOaInfoRsp = WithTypeCast<
RecursiveNonNullable<trpc.rmonitor.product_manager.IGetProductOaInfoRsp>>;

export type IProductOaInfo = WithTypeCast<RecursiveNonNullable<trpc.rmonitor.product_manager.IProductOaInfo>>;
export type PlatformType = WithTypeCast<trpc.rmonitor.product_manager.PlatformType>;
export type ISearchProductOaListReq = WithTypeCast<trpc.rmonitor.product_manager.ISearchProductOaListReq>;
export type ISearchProductOaListRsp = WithTypeCast<
RecursiveNonNullable<trpc.rmonitor.product_manager.ISearchProductOaListRsp>>;

export type IUpdateProductInfoReq = WithTypeCast<trpc.rmonitor.product_manager.IUpdateProductInfoReq>;
export type IUpdateProductInfoRsp = WithTypeCast<trpc.rmonitor.product_manager.IUpdateProductInfoRsp>;

export const { PlatformType } = trpc.rmonitor.product_manager;

// 产品
class ProductOAServer extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.ProductOAServer,
    });
  }

  /**
   * 添加产品
   */
  public async addProductOa(req: IAddProductOaReq): Promise<IAddProductOaRsp> {
    try {
      return await this.trpcPost<IAddProductOaRsp>('AddProductOa', req, {
        ignoreError: true,
      });
    } catch (e) {
      logger.error('AddProductOa e:', e);
      return {};
    }
  }

  /**
   * 删除产品
   */
  public async deleteProductOa(req: IDeleteProductOaReq): Promise<boolean> {
    try {
      const rsp =  await this.trpcPost<IDeleteProductOaRsp>('DeleteProductOa', req);
      return rsp?.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      logger.error('DeleteProductOa e:', e);
      return false;
    }
  }

  /**
   * 更新产品
   */
  public async updateProductOa(req: IUpdateProductOaReq, config?: TrpcRequestConfig): Promise<boolean> {
    try {
      const rsp = await this.trpcPost<IUpdateProductOaRsp>('UpdateProductOa', req, config);
      return rsp?.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      logger.error('UpdateProductOa e:', e);
      return false;
    }
  }

  /**
   * 获取产品列表
   */
  public async getProductOaList(req: IGetProductOaListReq): Promise<IProductOaListElem[]> {
    try {
      const rsp = await this.trpcPost<IGetProductOaListRsp>('GetProductOaList', req);
      return rsp?.productInfoList || [];
    } catch (e) {
      logger.error('GetProductOaList e:', e);
      return [];
    }
  }

  /**
   * 获取单个产品信息
   */
  public async getProductOaInfo(req: IGetProductOaInfoReq): Promise<IProductOaInfo | undefined> {
    try {
      const rsp = await this.trpcPost<IGetProductOaInfoRsp>('GetProductOaInfo', req);
      return rsp?.productInfo || {};
    } catch (e) {
      logger.error('GetProductOaInfo e:', e);
      return undefined;
    }
  }

  /**
   * 超管搜索产品
   */
  public async searchProductOaList(req: ISearchProductOaListReq): Promise<IProductOaInfo[]> {
    try {
      const rsp = await this.trpcPost<ISearchProductOaListRsp>('SearchProductOaList', req);
      return rsp?.productInfo ?? [];
    } catch (e) {
      logger.error('searchProductOaList e:', e);
      return [];
    }
  }

  /**
   * 超管修改产品
   */
  public async updateProductInfo(req: IUpdateProductInfoReq, config?: TrpcRequestConfig): Promise<boolean> {
    try {
      const rsp = await this.trpcPost<IUpdateProductInfoRsp>('UpdateProductInfo', req, config);
      return rsp?.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      logger.error('searchProductOaList e:', e);
      return false;
    }
  }
}

export const productOAServer = new ProductOAServer();
